import { viaCepApi } from '@ibk/shared-config';
export const cepApi = viaCepApi.injectEndpoints({
    endpoints: build => ({
        getCepData: build.query({
            query: ({ cep }) => ({
                method: 'GET',
                url: `/ws/${cep}/json/`,
            }),
            transformResponse: (response) => {
                return response;
            },
            providesTags: ['cep'],
        }),
    }),
    overrideExisting: false,
});
export const { useLazyGetCepDataQuery } = cepApi;
